module.exports = __webpack_public_path__ + "static/img/zhuanti3.c1eade92.png";